/**
 * HTTP status codes the app reacts to by name.
 * Migrated from legacy `root/models/http-response-code.model.ts` (a class of
 * statics there; a plain const object here, per the starter's conventions).
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,

  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  /** The backend's channel for custom, message-driven errors. */
  IM_A_TEAPOT: 418,

  INTERNAL_SERVER_ERROR: 500,
} as const;

export function isSuccessStatus(status: number): boolean {
  return status >= 200 && status < 300;
}
